<template lang='pug'>
  vm-row.login-row(vm-w="12")
        vm-col.login-col(vm-justify="center", vm-align="center", vm-lg=4, vm-sm=12)
            form#login(autocomplete="off", @submit.prevent="login" method="post")
                .img-container
                    img.logo(src="@/assets/logo.png" @click="$router.push( '/' )")
                b-form-group
                    h1 {{ $t('login.login') }}

                b-form-group
                    vm-input(icon='email-outline', :placeholder='$t("login.email")' v-model="form.email" required autofocus type="email")
                    span.help-block(v-if='authError')
                        strong {{ $t('auth.failed') }}

                b-form-group
                    vm-input(type="password" icon='lock-outline' :placeholder='$t("login.password")' v-model="form.password" required pass)

                b-form-group#boxes
                    .d-flex.justify-content-between
                        vm-checkbox(v-model='form.rememberMe') {{ $t('login.keep_connected') }}

                        router-link.content-vertical.text-secondary(to='/password/reset') {{ $t('login.forgot_password') }}

                b-form-group
                    vm-button#loginButton.vm-con-loading__container(color="primary", type="filled" width="100%") {{ $t('login.login') }}

                b-form-group
                    .msg
                        span No tienes una cuenta?&nbsp;
                            router-link.content-vertical.text-secondary(to='/register') Crear cuenta.
        vm-col.login-background(
            vm-align="center",
            vm-lg=8,
            vm-sm=0,
            vm-xs=0,
            vm-offset=4
            :style="{ background: 'url(/Background.jpg) no-repeat center / cover ' }"
        )
</template>

<script>
import vmFacebook from '@/components/buttons/vm-facebook'
import vmGoogle from '@/components/buttons/vm-google'
import formValidation from '@/utils/formValidations'
import { mapActions } from 'vuex'

export default {
  name: 'login',
  components: {
    vmFacebook,
    vmGoogle
  },
  data () {
    return {
      form: {
        email: 'admin@example.com',
        password: 'admin',
        rememberMe: true
      },
      authError: false
    }
  },
  methods: {
    ...mapActions({
      loadData: 'loadData',
      setAlertMessage: 'setAlertMessage'
    }),
    async doLogin () {
      await this.$auth.login({
        data: this.form,
        async success (response) {
          const { status } = response
          // Uncomment this two lines if having troubles with authentication in local development
          await this.$auth.token('default_auth_token', response.data.access_token)
          await this.$auth.fetch()

          if (status === 401) {
            this.authError = true
          } else if (status === 403) {
            this.$router.push({ name: 'verification.notice', params: { user_id: response.data.id, email: this.form.email } })
          } else {
            this.loadData()
          }
        },
        rememberMe: this.form.rememberMe,
        redirect: '/'
      }).catch(error => {
        this.setAlertMessage({ color: 'danger', title: 'errors.connection_error', text: error.response.data.original.message })
      })
    },
    async socialAuth (payload) {
      await this.$auth.login({
        url: '/auth/' + payload.provider + '/callback',
        params: {
          token: payload.response.accessToken
        },
        success (response) {
          const { status } = response
          if (status === 401) {
            this.authError = true
          }
          this.loadData()
        },
        rememberMe: this.form.rememberMe,
        redirect: '/'
      }).catch(error => {
        this.setAlertMessage({ color: 'danger', title: 'errors.connection_error', text: error.response.data.original.message })
      })
    },
    async login (evt) {
      if (!formValidation(evt)) return
      this.$vm.loading({
        background: 'primary',
        color: '#fff',
        container: '#loginButton',
        scale: 0.45
      })
      try {
        await this.doLogin()
      } catch (error) {
        this.setAlertMessage({ color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' })
      }
      this.$vm.loading.close('#loginButton > .con-vm-loading')
    }
  }
}
</script>

<style lang="scss" scoped>
#loginButton {
    width: 100%;
}

.msg {
    text-align: center;
    margin-top: 10px;
}

.img-container {
    width: 100%;
    text-align: center;
    margin-bottom: 30px;
}

.logo {
    width: 150px;
    height: auto;
    cursor: pointer;
}

.social {
    display: flex;
    justify-content: space-around;
}

.vm-input {
    color: #5b5777;

    .vm-input--icon {
        color: rgba(0, 0, 0, .4) !important;
    }
}

@media only screen and (max-width: 768px) {
    #loginButton {
        width: 100%;
    }

    .msg {
        text-align: center;
        margin-top: 10px;
    }
}

.container-fluid {
    height: 100vh;
    padding-right: 0px !important;
    padding-left: 0px !important;
}

form {
    margin-left: auto;
    margin-right: auto;
    margin-top: 35px;
    max-width: 380px;
}

.login-background {
    height: 100vh;
    padding-left: 42%;
}

.login-col {
    -webkit-transition: all .3s;
    transition: all .3s;
    padding: 50px;
    position: fixed;
    background-color: white;
    height: 100%;
    overflow: auto;
}

.login-screen,
.login-row {
    height: 100%;
}

.logo {
    margin-top: 0px;
}

.reset-password {
    padding-top: 0px;
}

.title {
    color: #000000;
    font-size: 17px;
    font-weight: 500;
    line-height: 1.1;
    margin-bottom: 20px;
}

.welcome {
    color: #ffffff;
    max-width: 555px;
    margin-bottom: 65px;
    margin-top: 65px;
    padding-right: 55px;

    h1 {
        font-size: 60px;
    }

    .sub-text {
        color: #ffffff;
    }
}

@media (min-width: 768px) {
    .login-screen {
        form {
            margin-top: 150px;
        }
    }

    .logo {
        margin-top: 50px;
    }

    .welcome {
        margin-bottom: 0px;
        margin-top: 285px;
    }
}

@media only screen and (max-width: 768px) {

    /* For mobile phones: */
    .container-fluid {
        height: 90vh;
    }

    .login-row {
        .login-col {
            -webkit-transition: all .3s;
            transition: all .3s;
            position: fixed;
            bottom: 0;
            height: auto;
            border-radius: 40px 40px 0px 0px;

            form {
                margin-top: 45px !important;
            }
        }

        .login-background {
            display: none;
        }
    }
}
</style>
